import '../scss/location-filter.scss';

class LocationFilter {
  constructor() {
    this.buttons = document.querySelectorAll('.koc_locations_v2_location-filter-button');
    this.items = document.querySelectorAll('.koc_locations_v2_location-grid-item');
    this.init();
  }

  init() {
    // Initial height matching after content is likely loaded
    window.addEventListener('load', () => this.matchHeights());
    window.addEventListener('resize', () => this.matchHeights());

    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        const filter = button.id;
        
        // Update active button state
        this.buttons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        this.filterLocations(filter);
      });
    });
  }

  matchHeights() {
    // Reset heights first to get natural height
    this.items.forEach(item => {
      item.style.height = 'auto';
    });

    let maxHeight = 0;
    
    // Find the max height among visible items
    this.items.forEach(item => {
      if (window.getComputedStyle(item).display !== 'none') {
        const height = item.getBoundingClientRect().height;
        if (height > maxHeight) {
          maxHeight = height;
        }
      }
    });

    // Apply max height to visible items
    if (maxHeight > 0) {
      this.items.forEach(item => {
        if (window.getComputedStyle(item).display !== 'none') {
          item.style.height = `${maxHeight}px`;
        }
      });
    }
  }

  filterLocations(filter) {
    // Phase 1: Fade out
    this.items.forEach(item => {
      item.style.transition = 'opacity 0.3s ease';
      item.style.opacity = '0';
    });

    // Phase 2: Switch visibility and fade in
    setTimeout(() => {
      this.items.forEach(item => {
        const category = item.getAttribute('data-koc_locations_v2_category');
        // "All" respects the shortcode's branch filter (avoids duplicate cards);
        // specific filters show every matching location, including branch-hidden ones.
        const isMatch = filter === 'all'
          ? !item.classList.contains('koc_locations_v2_hide_location')
          : category === filter;
        if (isMatch) {
          item.style.display = 'flex';
          // Small delay to ensure display is applied before opacity
          setTimeout(() => {
            item.style.opacity = '1';
          }, 10);
        } else {
          item.style.display = 'none';
        }
      });

      // Recalculate heights after visibility change
      setTimeout(() => {
        this.matchHeights();
      }, 50);

    }, 300);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new LocationFilter();
});
